import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { environment } from 'src/environments/environment';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatSortModule } from '@angular/material/sort';

import { NgDynamicBreadcrumbModule } from 'ng-dynamic-breadcrumb';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { Ng7DynamicBreadcrumbModule } from 'ng7-dynamic-breadcrumb';
import { SocketIoConfig, SocketIoModule } from 'ngx-socket-io';
import { ToastrModule } from 'ngx-toastr';
import { NgxUiLoaderConfig, NgxUiLoaderModule } from 'ngx-ui-loader';

import { GoogleLoginProvider } from './../../projects/lib/src/providers/google-login-provider';
import { SocialAuthService, SocialAuthServiceConfig } from './../../projects/lib/src/socialauth.service';
import { SocialLoginModule } from './../../projects/lib/src/sociallogin.module';

import { BillabilityComponent } from './admin/billability/billability.component';
import { CareerComponent } from './admin/career/career.component';
import { ClientManagementComponent } from './admin/client-management/client-management.component';
import { MyInterceptor } from './config/http.interceptor';
import { NotificationService } from './config/notification.service';
import { DashboardComponent } from './admin/dashboard/dashboard.component';
import { GoogleLoginComponent } from './admin/google-login/google-login.component';
import { ContentComponent } from './admin/layouts/content/content.component';
import { FooterComponent } from './admin/layouts/footer/footer.component';
import { HeaderComponent } from './admin/layouts/header/header.component';
import { MenuListItemComponent } from './admin/layouts/menu-list-item/menu-list-item.component';
import { ManagementComponent } from './admin/management/management.component';
import { MaterialModuleModule } from './material-module/material-module.module';
import { NotFoundComponent } from './admin/not-found/not-found.component';
import { PrRequestApproveComponent } from './admin/pr-request-approve/pr-request-approve.component';
import { ProfileComponent } from './admin/profile/profile.component';
import { ProjectManagementComponent } from './admin/project-management/project-management.component';
import { PurchaseManagementComponent } from './admin/purchase-management/purchase-management.component';
import { ResourceManagementComponent } from './admin/resource-management/resource-management.component';
import { SopsComponent } from './admin/sops/sops.component';
import { ResumeComponent } from './admin/resume/resume.component';
import { PmsLogsComponent } from './admin/pms-logs/pms-logs.component';
import { ResourceRequestApproveComponent } from './admin/resource-request-approve/resource-request-approve.component';
import { ForgotPasswordComponent } from './admin/auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './admin/auth/reset-password/reset-password.component';

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  "fgsSize": 30,
  "pbColor": "#192B6E",
  "fgsColor": "#192B6E",
  "overlayColor": "rgba(0, 0, 0, 0.1)",
  "hasProgressBar": false,
};

const config: SocketIoConfig = {
  url: environment.socketUrl,
  options: {
    path: environment.socketPath
  }
};

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    MenuListItemComponent,
    DashboardComponent,
    ContentComponent,
    ManagementComponent,
    GoogleLoginComponent,
    ClientManagementComponent,
    ProjectManagementComponent,
    BillabilityComponent,
    NotFoundComponent,
    ProfileComponent,
    CareerComponent,
    PurchaseManagementComponent,
    PrRequestApproveComponent,
    ResourceManagementComponent,
    SopsComponent,
    ResumeComponent,
    PmsLogsComponent,
    ResourceRequestApproveComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent
  ],
  imports: [
    BrowserModule,
    NgDynamicBreadcrumbModule,
    Ng7DynamicBreadcrumbModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModuleModule,
    SocialLoginModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgApexchartsModule,
    MatSortModule,
    NgbPaginationModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    ToastrModule.forRoot(),
    SocketIoModule.forRoot(config)
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MyInterceptor,
      multi: true
    },
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              `${environment.clientId}` // add web app client id
            )
          }
        ]
      } as SocialAuthServiceConfig
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'en-GB'
    },
    SocialAuthService,
    NotificationService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
